import {Component, Input, OnInit, Optional} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';
import {AirMatchingReportService} from '../../service/air-matching-report.service';
import {take} from 'rxjs';
import {AirMatchingReportFilter} from '../../model/air-matching-report';
import {DynamicAutocompleteItem} from '../../../shared/service/dynamic-autocomplete/dynamic-autocomplete.service';

@AutoUnsubscribe()
@Component({
    selector: 'air-matching-report-filter',
    templateUrl: './air-matching-report-filter.component.html',
    standalone: false
})
export class AirMatchingReportFilterComponent implements OnInit {
    @Input() config!:AirMatchingReportFilter;

    filterForm!:FormGroup;
    
    adxReferenceControl = new FormControl<DynamicAutocompleteItem | null>(null);
    sabreReferenceControl = new FormControl<DynamicAutocompleteItem | null>(null);

    constructor(
        @Optional() public dialogRef: MatDialogRef<AirMatchingReportFilterComponent>,
        private formBuilder:FormBuilder,
        private airMatchingReportService: AirMatchingReportService,
    ){
        this.filterForm = this.formBuilder.group({
            adxReference: this.adxReferenceControl,
            sabreReference: this.sabreReferenceControl,
            sabreInvoiceIssueDateFrom: null,
            sabreInvoiceIssueDateTo: null,
        });
        
     }

    ngOnInit(): void {
        this.airMatchingReportService.getAirMatchingFilter()
        .pipe(take(1))
        .subscribe((filter: AirMatchingReportFilter) => {
            this.config = filter;
            
            // Handle autocomplete field restoration
            if (filter) {
                if (filter.adxReference && typeof filter.adxReference === 'string') {
                    this.adxReferenceControl.setValue({
                        value: filter.adxReference,
                        originalValue: filter.adxReference
                    });
                }
                
                if (filter.sabreReference && typeof filter.sabreReference === 'string') {
                    this.sabreReferenceControl.setValue({
                        value: filter.sabreReference,
                        originalValue: filter.sabreReference
                    });
                }
                
                // Patch other fields but exclude the autocomplete fields we just handled
                const { adxReference, sabreReference, ...otherFields } = filter;
                this.filterForm.patchValue(otherFields);
            } else {
                this.filterForm.patchValue(this.config || {});
            }
        });
    }

    applyFilters(){
        this.config = this.filterForm.value;
        
        if (typeof this.config.adxReference === 'object' && this.config.adxReference !== null) {
            this.config.adxReference = (this.config.adxReference as any).value || (this.config.adxReference as any).toString();
        }
        this.config.adxReference = this.config.adxReference?.trim();
        
        if (typeof this.config.sabreReference === 'object' && this.config.sabreReference !== null) {
            this.config.sabreReference = (this.config.sabreReference as any).value || (this.config.sabreReference as any).toString();
        }
        this.config.sabreReference = this.config.sabreReference?.trim();
        
        this.closeModal(this.config);
    }

    closeModal(config?: AirMatchingReportFilter) {
        if (config) {
            this.airMatchingReportService.setAirMatchingFilter(config);
        }
        this.dialogRef.close(config);
    }

    clearFields(...args:string[]){
        if(!args.length) {
            this.filterForm.reset();
            return;
        }
        args.forEach((field)=>{
            this.filterForm.controls[field].reset()
        })
    }
}
